document.addEventListener('DOMContentLoaded', () => {
  if (!window.matchMedia('(min-width: 750px) and (hover: hover)').matches) return;

  document.querySelectorAll(
    '.product__modal-opener--image .product__media'
  ).forEach(container => {
    const img = container.querySelector('img');
    if (!img) return;

    container.addEventListener('mousemove', e => {
      const rect = container.getBoundingClientRect();

      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;

      img.style.transformOrigin = `${x}% ${y}%`;
    });

    container.addEventListener('mouseleave', () => {
      img.style.transformOrigin = 'center center';
    });
  });
});
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('media-gallery').forEach(gallery => {
    const prev = gallery.querySelector('.calzamundo-gallery-prev');
    const next = gallery.querySelector('.calzamundo-gallery-next');

    if (!prev || !next) return;

    const items = [...gallery.querySelectorAll(
      '.thumbnail-list__item[data-target]'
    )];

    if (items.length < 2) return;

    function navigate(direction) {
      const active = gallery.querySelector(
        '.product__media-list > .product__media-item.is-active'
      );

      if (!active) return;

      const currentIndex = items.findIndex(
        item => item.dataset.target === active.dataset.mediaId
      );

      if (currentIndex === -1) return;

      const nextIndex =
        (currentIndex + direction + items.length) % items.length;

      gallery.setActiveMedia(items[nextIndex].dataset.target, false);
    }

    prev.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      navigate(-1);
    });

    next.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      navigate(1);
    });
  });
});